import React from 'react'
import { connect } from 'react-redux'
import { Switch } from 'react-router'
import {
    Button,
    ButtonGroup,
    Classes,
    Dialog,
    Icon,
    MenuItem,
    Spinner,
} from '@blueprintjs/core'

import CustomerSelect from 'src/components/CustomerSelect'
import InputSelect from 'src/components/InputSelect'
import { toggleControl } from 'src/store/modules/ui/runbook/controls'
import {
    clearSearchCustomers,
    getCustomerById,
} from 'src/store/modules/cmdb/customers'
import {
    searchDevices,
    getDeviceResults,
    clearSearchDevices,
} from 'src/store/modules/cmdb/devices'
import {
    getAction,
    addSolutionWithChildren,
    addNewSolution,
} from 'src/store/modules/runbooks/actions'
import { clearSelectedCustomer } from 'src/store/modules/cmdb/solutions'
import * as solutionModules from 'src/store/modules/cmdb/solutions'

class SolutionDialog extends React.Component {
    state = {
        asChild: true,
        selectedDevice: null,
        selectedAvZones: [],
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.solutionInput) this.solutionInput.focus()
        }, 300)
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            setTimeout(() => {
                if (this.solutionInput) this.solutionInput.focus()
            }, 300)
        }
    }

    solutionInputRef = (ref) => (this.solutionInput = ref)

    deviceRenderer = (item, { handleClick, modifiers }) => {
        return (
            <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={(item.name && `${item.id} - ${item.name}`) || item.id}
            />
        )
    }

    handleAvZoneSelect = (avZ) => () => {
        const { selectedAvZones } = this.state
        if (selectedAvZones.includes(avZ)) {
            this.setState({
                selectedAvZones: [...selectedAvZones.filter((z) => z !== avZ)],
            })
        } else {
            this.setState({ selectedAvZones: [...selectedAvZones, avZ] })
        }
    }

    handleCloseSolution = () => {
        this.setState({
            selectedDevice: null,
            selectedAvZones: [],
            asChild: true,
        })
        this.props.toggleControl('isManipulatingSolution')
        this.props.clearSelectedCustomer()
        this.props.clearSearchCustomers()
        this.props.clearSearchDevices()
    }

    handleSaveSolution = () => {
        const { selectedDevice, selectedAvZones, asChild } = this.state
        // this.props.addSolutionWithChildren(
        //     this.props.activeRunbook,
        //     this.props.action.uid,
        //     selectedDevice,
        //     selectedAvZones,
        //     asChild
        // )
        this.props.addNewSolution(
            this.props.activeRunbook,
            this.props.action.uid,
            selectedDevice,
            selectedAvZones,
            asChild
        )
        this.handleCloseSolution()
    }

    handleCustomerSelect = (customer) => {
        this.props.onCustomerSelect(customer.id)
    }

    render() {
        const {
            visible,
            action,
            devices,
            devicesLoading,
            searchDevices,
            selectedCustomer,
        } = this.props
        const { selectedDevice, selectedAvZones, asChild } = this.state
        if (!visible) {
            return null
        }
        return (
            <Dialog
                onClose={this.handleCloseSolution}
                title={`Add solution to ${action.uid}. ${action.name}`}
                isOpen={true}
                canOutsideClickClose={false}
            >
                <div className={Classes.DIALOG_BODY}>
                    <div style={{ marginBottom: 5 }}>
                        <CustomerSelect
                            selected={selectedCustomer}
                            onCustomerSelect={this.handleCustomerSelect}
                        />
                    </div>
                    <div style={{ marginBottom: 5 }}>
                        <InputSelect
                            items={devices}
                            itemRenderer={this.deviceRenderer}
                            inputValueRenderer={(i) => i.name || i.id}
                            noResults={
                                <MenuItem disabled={true} text="No results." />
                            }
                            onItemSelect={(item) =>
                                this.setState({
                                    selectedDevice: item,
                                })
                            }
                            inputProps={{
                                inputRef: this.solutionInputRef,
                                disabled: !selectedCustomer,
                                placeholder: 'Search for a solution',
                                rightElement: devicesLoading ? (
                                    <Spinner size={Icon.SIZE_STANDARD} />
                                ) : null,
                            }}
                            onQueryChange={(value) =>
                                searchDevices(value, selectedCustomer.id, true)
                            }
                            popoverProps={{
                                className: 'multiselect_wrapper',
                                minimal: true,
                            }}
                        />
                    </div>

                    {selectedDevice && selectedDevice.avZones.length !== 0 && (
                        <div>
                            <ButtonGroup>
                                {selectedDevice.avZones.map((avZ) => (
                                    <Button
                                        key={avZ}
                                        onClick={this.handleAvZoneSelect(avZ)}
                                        active={selectedAvZones.includes(avZ)}
                                    >
                                        {avZ}
                                    </Button>
                                ))}
                            </ButtonGroup>
                        </div>
                    )}
                    <div style={{ paddingTop: 10, textAlign: 'center' }}>
                        <Switch
                            onChange={() =>
                                this.setState({ asChild: !asChild })
                            }
                            checked={asChild}
                            innerLabelChecked="Split Branch"
                            innerLabel="Continue Branch"
                        />
                    </div>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            large
                            disabled={!selectedDevice}
                            onClick={this.handleSaveSolution}
                            intent="primary"
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={this.handleCloseSolution}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

export default connect(
    (state) => ({
        activeRunbook: state.ui.runbook.activeRunbook,
        action: getAction(
            state,
            state.ui.runbook.activeRunbook,
            state.ui.runbook.controls.singleOpenAction
        ),
        devices: getDeviceResults(state),
        devicesLoading: state.cmdb.devices.loading,
        visible: state.ui.runbook.controls.isManipulatingSolution,
        selectedCustomer: getCustomerById(
            state,
            state.cmdb.solutions.selectedCustomer
        ),
    }),
    {
        toggleControl,
        searchDevices,
        clearSelectedCustomer,
        clearSearchCustomers,
        clearSearchDevices,
        addSolutionWithChildren,
        addNewSolution,
        onCustomerSelect: (customerId) =>
            solutionModules.selectCmdbSolutionCustomer(customerId),
    }
)(SolutionDialog)
